import { render, staticRenderFns } from "./CompetitionListMyCompetitionLayout.vue?vue&type=template&id=66ff0442&scoped=true&"
import script from "./CompetitionListMyCompetitionLayout.vue?vue&type=script&lang=js&"
export * from "./CompetitionListMyCompetitionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ff0442",
  null
  
)

export default component.exports